/**
 * This file was auto-generated by Fern from our API Definition.
 */

/**
 * A file object that can be used to read a file resource.
 */
export interface File_ {
    /** Primitive string type. */
    contentType?: string;
    /**
     * The [Multibase](https://www.w3.org/TR/cid/#multibase)-encoded sha2-256 [Multihash](https://www.w3.org/TR/cid/#multihash) value.
     *
     * See [Resource Integrity](https://www.w3.org/TR/vc-data-integrity/#resource-integrity).
     */
    digestMultibase: string;
    /** Primitive string type. */
    filename: string;
    /** The size of the file in bytes. */
    filesize: number;
    /** Just regular URI according to [RFC 3986](https://www.rfc-editor.org/rfc/rfc3986). */
    id: string;
}
